import { useT } from '@platform/i18n';
import type { GuidanceStatus } from '../types';

const TONE_BY_STATUS: Record<GuidanceStatus, string> = {
  'detecting': 'bg-zinc-700 text-zinc-100',
  'no-face': 'bg-amber-600 text-white',
  'multiple-faces': 'bg-amber-600 text-white',
  'too-small': 'bg-amber-600 text-white',
  'off-center': 'bg-amber-600 text-white',
  'face-unclear': 'bg-amber-600 text-white',
  'ready': 'bg-emerald-600 text-white',
  'hold-still': 'bg-emerald-600 text-white',
  'detector-unavailable': 'bg-zinc-700 text-zinc-100',
};

export function GuidanceBanner({ status }: { status: GuidanceStatus }) {
  const { t } = useT('face-capture');
  return (
    <p
      role="status"
      className={`w-fit max-w-full rounded-full px-4 py-2 text-center text-sm font-medium shadow-md ${TONE_BY_STATUS[status]}`}
    >
      {t(`guidance.${status}`)}
    </p>
  );
}
